import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import microsoftIcon from 'assets/img/microsoftIcon.svg';

interface MicrosoftButtonProps extends PropsWithChildren {
  className?: string;
  onClick: () => void;
}

function MicrosoftButton({ className, onClick, children }: MicrosoftButtonProps) {
  return (
    <div
      role="button"
      onClick={onClick}
      className={classNames(
        'flex flex-row items-center border border-green-600 bg-green-600 font-semibold text-white',
        className
      )}
    >
      <div className="mr-2 bg-white p-2">
        <img src={microsoftIcon} />
      </div>
      <div className="flex w-full items-center justify-center">{children}</div>
    </div>
  );
}

export default MicrosoftButton;
